export type QrCodeProvider = 'Pix';

export const paymentMethodToQrCodeProvider: Record<string, QrCodeProvider> = {
  Pix: 'Pix',
};
